/**
 * Defines facebook tag event IDs, and puts them into nice names.
 * See https://developers.facebook.com/docs/facebook-pixel/api-reference#events for a list of events
 */
export default {
    STANDARD_EVENTS: [
        "AddPaymentInfo",
        "AddToCart",
        "AddToWishlist",
        "CompleteRegistration",
        "InitiateCheckout",
        "Lead",
        "PageView",
        "Purchase",
        "Search",
        "ViewContent",
    ],

    ADD_TO_CART: "AddToCart",
    EMAIL_SIGNUP: "EmailSignUp",
    LEAD: "Lead",
    PAGE_VIEW: "PageView",
    REGISTRATION_COMPLETE: "CompleteRegistration",
    VIEW_CONTENT: "ViewContent",
};
